<template>
  <b-modal
    class="scrollbar-hide price-modal"
    :active="inclusionsModal.value"
    scroll="keep"
    :can-cancel="['escape', 'x', 'outside']"
    @close="closeModal"
    @active-change="updateModalStatus"
  >
    <div class="card scollbar-hide">
      <div class="card-content">
        <h2 class="price-heading">Price</h2>
        <div class="text-left mt-24">
          <h1 class="modal-heading">Included at this price:</h1>
          <ul class="mt-24">
            <li
              v-for="included in displayIncludedData"
              :key="included.index"
            >
              {{ included }}
            </li>
          </ul>
        </div>
        <div class="text-left mt-24">
          <h1 class="modal-heading">Excluded at this price:</h1>
          <ul class="mt-24">
            <li
              v-for="excluded in displayExcludedData.filter(Boolean)"
              :key="excluded.index"
            >
              {{ excluded }}
            </li>
          </ul>
        </div>
        <div class="modal-divider"></div>
        <div class="modal-close-container">
          <div @click="closeModal" class="close-button">Close</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { FeesData } from "@/services/Fees.js";

export default {
  name: "inclusionsModal",
  props: {
    inclusionsModal: {
      type: Object,
      default: () => ({ key: null, value: false }),
    },
    currentIndex: Number,
    rateType: String,
    superExcludedProps: Object,
    standardExcludedProps: Object,
    onewayFeePrompt: String,
    listingDetails: Object,
  },
  data() {
    return {
      standardIncluded: [
        "Vat @ 15%",
        "200km per day",
        "Airport surcharge",
        "Tourism levy",
        "Standard collision damage waiver",
        "Standard theft waiver",
        "First additional driver",
      ],
      superIncluded: [
        "Vat @ 15%",
        "Unlimited mileage",
        "Airport surcharge",
        "Tourism levy",
        "Super collision damage waiver",
        "Super theft waiver",
        "First additional driver",
        "Contract / Admin fee",
        "Delivery and collection fee in a radius of 20km during office hours",
      ],
      expressIncluded: [
        "Vat @ 15%",
        "Unlimited mileage",
        "Airport surcharge",
        "Tourism levy",
        "Super collision damage waiver",
        "Super theft waiver",
        "First additional driver",
        "Contract / Admin fee",
        "Delivery and collection fee in a radius of 20km during office hours",
        "No paperwork at pick up",
        "Tyre and windscreen cover",
      ]
    };
  },
  computed: {
    fees() {
      return FeesData;
    },
    displayIncludedData(){
      if (this.rateType === 'Standard') return this.standardIncluded;
      if (this.rateType === 'Super') return this.superIncluded;
      if (this.rateType === 'Express Lane') return this.expressIncluded;
      return "";
    },
    displayExcludedData(){
      if (this.rateType === 'Standard') return this.standardExcluded;
      if (this.rateType === 'Super') return this.superExcluded;
      if (this.rateType === 'Express Lane') return this.superExcluded;
      return "";
    },
    standardExcluded() {
      return [
        `R${this.listingDetails.mileagePrice} per excess km`,
        `Contract / admin fee of R${this.fees.adminFee} per rental`,
        `Excess payable of R${this.listingDetails.excess.standard} per rental agreement per claim due to accident or theft. No hold is placed on your Investec Visa card. Double excess is applicable where no other vehicle or third party involved in the accident`,
        `Claims administration fee: In the event of damages a claims handling fee of R${this.fees.claimsAdminFee} will be charged, and debited within fifteen working days after the car is returned`,
        `A second additional driver: An additional charge of R${this.fees.additionalDriverFee} is applicable`,
        `Young driver surcharge(18-20 years old): An additional charge of R${this.fees.youngDriverSurcharge}/day is applicable`,
        `Fuel: A deposit of R${this.fees.fuelDepositRegular}/R${this.fees.fuelDepositSUV}(LDV & SUV) is taken by the rental agency when you collect the car and sign the rental conditions. This deposit less any charges payable to the rental agency is refundable within 5-8 working days` ,
        `Refuel: Actual charge + R${this.fees.refuelFee} service fee`,
        `E-Tolling fees: Debited within eight working days after the car is returned. A ${this.fees.eTollAdminFee} e-toll admin fee will be added to the e-toll fees`,
        `Fines and fine handling fees: Please note that fines can take up to 12 months to be redirected to you, in which you will be responsible for full settlement of:`,
        `Baby/Child/Booster seat: R${this.fees.babySeat}`,
        `Traffic fine administration fee (charged per fine) of R${this.fees.trafficFineAdminFee} is charged in addition to the actual fine amount, in order to cover the cost of redirecting the fine to you`,
        `Towing costs and storage charges as well as charges for roadside assistance (unless there was mechanical breakdown). These fees are charged in addition to the liability amount / damage amount and are dependent on the rental agency`,
        `Additional charges such as bike rack/s, GPS, baby/child seat/s will be subject to a liability of R${this.fees.extrasDamageLiabilityFee} in the event of loss or damage`,
        `Tyre and windscreen waivers: Tyre and windscreen waivers are optional and offered at R${this.fees.tyreAndWindscreenWaiver} per waiver, per day.`,
        `Cross-border authorisation fees of R${this.fees.crossBorderFee} apply for Lesotho, Swaziland, Botswana, Namibia and Zambia.`,
        `Cross Mozambique border authorisation fee of R${this.fees.mozambiqueFee} available on request only`,
        `One way drop off fee is charged when a vehicle is collected from one location and returned to a different location. To be quoted at the time of booking`,
        `Assessment fee in the event of an accident / damage to the hire car is charged at R${this.fees.damageAssessmentFee} per claim`,
        `Valet fee, dependent on the supplier and capped at R${this.fees.valetFee}`,
        `Delivery and collection fee during office hours (between 09h00 and 16h00 weekdays) within a 20 km radius a fee of R${this.fees.deliveryAndCollectionIn20km} and R${this.fees.deliveryAndCollectionOutside20km} per km thereafter applies. Afterhours (before 09h00 and after 16h00 during the week, public holiday’s and weekends) a fee of R${this.fees.deliveryAndCollectionIn20kmAfterhours} in a 20 km radius and R${this.fees.deliveryAndCollectionOutside20kmAfterhours} per km thereafter`,
        `Driving on Gravel roads is not recommended. Should any undercarriage damage occur while driving on a gravel road, the excess will not be applicable and the Renter will be liable for the full cost of repair. Should any incident occur while driving on a gravel road as a result of negligence or breach of contract, the Renter will liable for the full replacement cost of the vehicle. Any accident occurring on a gravel road will carry a double excess liability but excludes undercarriage damage which will be billed in full`,
        `Water damage is excluded from the excess liability. The Renter will be liable for full or replacement cost as a result of water damage.`,
        `Overdue penalty: R${this.fees.overduePenalty} per rental. This is only applicable where there has been no prior arrangements made for rental extension ahead of rental expiry date and time.`,
        `No show penalty: R${this.fees.noShowPenalty} + 1 days rental charge per rental. This is only applicable where there has been no prior arrangements made to cancel the booking ahead of the rental date and time.`,
        `**Airport surcharge may be charged by certain suppliers at ${this.fees.airportSurcharge} of the daily rate.`,
        `Should the renter be in possession of a C1 Driver's License which is less than 2 years old, double the rental deposit and excess would apply.`
      ];
    },
    superExcluded() {
      return [
        `Excess payable of R${this.listingDetails.excess.super} per rental agreement per claim due to accident or theft. No hold is placed on your Investec Visa card. Double excess is applicable where no other vehicle or third party involved in the accident`,
        `Claims administration fee: In the event of damages a claims handling fee of R${this.fees.claimsAdminFee} will be charged, and debited within fifteen working days after the car is returned`,
        `A second additional driver: An additional charge of R${this.fees.additionalDriverFee} is applicable`,
        `Young driver surcharge(18-20 years old): An additional charge of R${this.fees.youngDriverSurcharge}/day is applicable`,
        `Fuel: A deposit of R${this.fees.fuelDepositRegular}/R${this.fees.fuelDepositSUV}(LDV & SUV) is taken by the rental agency when you collect the car and sign the rental conditions. This deposit less any charges payable to the rental agency is refundable within 5-8 working days` ,
        `Refuel: Actual charge + R${this.fees.refuelFee} service fee`,
        `E-Tolling fees: Debited within eight working days after the car is returned. A ${this.fees.eTollAdminFee} e-toll admin fee will be added to the e-toll fees`,
        `Fines and fine handling fees: Please note that fines can take up to 12 months to be redirected to you, in which you will be responsible for full settlement of:`,
        `Baby/Child/Booster seat: R${this.fees.babySeat}`,
        `Traffic fine administration fee (charged per fine) of R${this.fees.trafficFineAdminFee} is charged in addition to the actual fine amount, in order to cover the cost of redirecting the fine to you`,
        `Towing costs and storage charges as well as charges for roadside assistance (unless there was mechanical breakdown). These fees are charged in addition to the liability amount / damage amount and are dependent on the rental agency`,
        `Additional charges such as bike rack/s, GPS, baby/child seat/s will be subject to a liability of R${this.fees.extrasDamageLiabilityFee} in the event of loss or damage`,
        (this.rateType !== 'Express Lane') ? `Tyre and windscreen waivers: Tyre and windscreen waivers are optional and offered at R${this.fees.tyreAndWindscreenWaiver} per waiver, per day.` : null,
        `Cross-border authorisation fees of R${this.fees.crossBorderFee} apply for Lesotho, Swaziland, Botswana, Namibia and Zambia.`,
        `Cross Mozambique border authorisation fee of R${this.fees.mozambiqueFee} available on request only`,
        `One way drop off fee is charged when a vehicle is collected from one location and returned to a different location. To be quoted at the time of booking.`,
        `Assessment fee in the event of an accident / damage to the hire car is charged at R${this.fees.damageAssessmentFee} per claim`,
        `Valet fee, dependent on the supplier and capped at R${this.fees.valetFee}`,
        `Delivery and collection fee during office hours (between 09h00 and 16h00 weekdays) within a 20 km radius a fee of R${this.fees.deliveryAndCollectionIn20km} and R${this.fees.deliveryAndCollectionOutside20km} per km thereafter applies. Afterhours (before 09h00 and after 16h00 during the week, public holiday’s and weekends) a fee of R${this.fees.deliveryAndCollectionIn20kmAfterhours} in a 20 km radius and R${this.fees.deliveryAndCollectionOutside20kmAfterhours} per km thereafter`,
        `Driving on Gravel roads is not recommended. Should any undercarriage damage occur while driving on a gravel road, the excess will not be applicable and the Renter will be liable for the full cost of repair. Should any incident occur while driving on a gravel road as a result of negligence or breach of contract, the Renter will liable for the full replacement cost of the vehicle. Any accident occurring on a gravel road will carry a double excess liability but excludes undercarriage damage which will be billed in full`,
        `Water damage is excluded from the excess liability. The Renter will be liable for full or replacement cost as a result of water damage.`,
        `Overdue penalty: R${this.fees.overduePenalty} per rental. This is only applicable where there has been no prior arrangements made for rental extension ahead of rental expiry date and time.`,
        `No show penalty: R${this.fees.noShowPenalty} + 1 days rental charge per rental. This is only applicable where there has been no prior arrangements made to cancel the booking ahead of the rental date and time.`,
        `**Airport surcharge may be charged by certain suppliers at ${this.fees.airportSurcharge} of the daily rate.`,
        `Should the renter be in possession of a C1 Driver's License which is less than 2 years old, double the rental deposit and excess would apply.`
      ];
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:inclusionsModal", { key: this.currentIndex, value: false });
    },
    updateModalStatus() {
      this.$emit("update:inclusionsModal", { key: this.currentIndex, value: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-24 {
  margin-top: 24px !important;
}
</style>
